import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../event/data.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-membership',
  templateUrl: './membership.component.html',
  styleUrls: ['./membership.component.css']
})
export class MembershipComponent implements OnInit{

  membership: FormGroup;
  loading: boolean = false;
  otherposition: string = undefined;
  otherownershiptype: string = undefined;
  othercompanyacquisition: string = undefined;
  othertotalrevenue: string = undefined;
  othertotalemployees: string = undefined;
  otherbusinesstype: string = undefined;
  otherfoundusthrough: string = undefined;
  otherallowlinkedin: string = undefined;
  myFormat = 'dd/MM/yyyy'
  isTouchedOrChanged = false;

  constructor(private formBuilder: FormBuilder, private dataService: DataService, private datePipe: DatePipe) {
    this.membership = this.formBuilder.group({
      title: [],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      dateofbirth: ['', Validators.required],
      companyname: ['', Validators.required],
      street: ['', Validators.required],
      zipcode: ['', Validators.required],
      city: ['', Validators.required],
      secondarystreet: [],
      secondaryzipcode: [],
      secondarycity: [],
      telephone: ['', Validators.required],
      mobile: [],
      email: ['', [Validators.required, Validators.email]],
      homepage: [],
      foundingyear: ['', Validators.required],
      shareholderstructure: [],
      companyacquisition: [],
      foundingwith: [],
      position: ['', Validators.required],
      businesstype: ['', Validators.required],
      companyobjective: ['', Validators.required],
      totalrevenue: ['', Validators.required],
      totalemployees: ['', Validators.required],
      ustid: ['', [Validators.required, Validators.pattern(/^DE[0-9]{9}$/)]],
      boardposition: [],
      operatinginternationally: [],
      foundusthrough: [],
      allowlinkedin: [],
      allowlinkedinCB: [],
      allowlinkedinCB2: [],
      accountholdername: [],
      creditinstitutionname: [],
      iban: [],
      bic: [],
      acceptTerms1: [null, Validators.requiredTrue],
      acceptTerms2: [null, Validators.requiredTrue]
    });
  }

  onSubmit() {
    // this.loading = true;
    if (this.membership.invalid) {
      this.membership.markAllAsTouched();  // Mark all fields as touched to display error messages
      this.loading = false;
      return;
    } else {
      this.membership.controls['position'].patchValue(this.otherposition ? this.otherposition : this.membership.controls['position'].value);
      this.membership.controls['shareholderstructure'].patchValue(this.otherownershiptype ? this.otherownershiptype : this.membership.controls['shareholderstructure'].value);
      this.membership.controls['businesstype'].patchValue(this.otherbusinesstype ? this.otherbusinesstype : this.membership.controls['businesstype'].value);
      this.membership.controls['foundusthrough'].patchValue(this.otherfoundusthrough ? this.membership.controls['foundusthrough'].value+' '+this.otherfoundusthrough : this.membership.controls['foundusthrough'].value);
      
      if (this.membership.controls['allowlinkedinCB'].value==true) {
        this.membership.controls['allowlinkedin'].patchValue("ja, man findet mich dort unter meinem vollen Namen oder");
        this.membership.controls['allowlinkedin'].patchValue(this.otherallowlinkedin ? this.membership.controls['allowlinkedin'].value+' '+this.otherallowlinkedin : this.membership.controls['allowlinkedin'].value);
      }
      if (this.membership.controls['allowlinkedinCB2'].value==true)
        this.membership.controls['allowlinkedin'].patchValue(this.membership.controls['allowlinkedin'].value+'|'+
"Ich bin einverstanden, dass der VdU mich in einem Social-Media Post als Neumitglied markiert und mein Foto, welches ich mit der Beitrittserklärung zusammen zur Verfügung stelle, verwendet werden darf.");

      this.membership.controls['totalemployees'].patchValue(this.othertotalemployees ? this.othertotalemployees : this.membership.controls['totalemployees'].value);
      this.membership.controls['companyacquisition'].patchValue(this.othercompanyacquisition ? this.othercompanyacquisition : this.membership.controls['companyacquisition'].value);
      this.membership.controls['totalrevenue'].patchValue(this.othertotalrevenue ? this.othertotalrevenue : this.membership.controls['totalrevenue'].value);

      const removeNullAndBooleanProperties = (obj: { [key: string]: any }) => {
        return Object.keys(obj).reduce((acc, key) => {
            const value = obj[key];
            if (typeof value !== 'boolean') {
                acc[key] = value;
            }
            if (key == 'dateofbirth' || key == 'foundingyear') {
                acc[key] = this.datePipe.transform(value, 'dd/MM/yyyy');
            }
            return acc;
        }, {} as { [key: string]: any });
      };
    
      const newObj = removeNullAndBooleanProperties(this.membership['value']);

      Swal.fire({
        title: 'Bitte warten Sie...',
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
            Swal.showLoading(null);
            this.dataService.postUserRegistrationForm(newObj).subscribe(res => {
              const result = res;
              if(result && result['status_code']==200){
                this.loading = false;
                Swal.fire({
                  title: "Vielen Dank für Ihr Interesse am VdU und Ihren Antrag.",
                  html: "Sie erhalten in Kürze eine Bestätigungsemail. Sie haben die Möglichkeit die Daten zu prüfen und zu bestätigen. Erst nach Erhalt Ihrer Bestätigung wird der Antrag in der Geschäftsstelle geprüft und bearbeitet.<br><br>Bitte bestätigen Sie Ihre Daten innerhalb der nächsten<br><b>72 Stunden.<b>",
                  icon: "success"
                });
                this.resetFormWithoutValidation(this.membership);
                this.otherallowlinkedin = this.otherbusinesstype = this.otherfoundusthrough = this.otherposition = undefined;
              } else if (result && result['status_code']!=200){
                if(result['status_code']==409){
                  this.loading = false;
                  Swal.fire({
                    title: "Entschuldigung",
                    text: "Dieser Benutzer existiert bereits in unserer Datenbank.",
                    icon: "warning"
                  });
                } else {
                  this.loading = false;
                  Swal.fire({
                    title: "Something Went Wrong",
                    text: "Please Try Again Later.",
                    icon: "warning"
                  });
                }
              } else {
                this.loading = false;
                Swal.fire({
                  title: "Something Went Wrong",
                  text: "Please Try Again Later.",
                  icon: "warning"
                });
              }
            });
        }
      });

      
    }
  }

  ngOnInit() {
    this.membership.valueChanges.subscribe(value => {
      // if(this.membership.controls['acceptTerms2'].value == true){
      //   if(this.membership.invalid){
      //     this.membership.controls['acceptTerms2'].patchValue(false);
      //   }
      // }
    });
  }

  resetFormWithoutValidation(form: FormGroup) {
    form.reset();
    this.membership.markAsUntouched();
    this.membership.markAsPristine();
  }

  validateUser(event){
    if(this.membership.controls['acceptTerms2'].value == true){
      if(this.membership.invalid){
        Swal.fire({
          title: "Ungültiges Formular",
          text: "Bitte füllen Sie alle erforderlichen Felder aus",
          icon: "error"
        }).then(()=>{
          this.membership.controls['acceptTerms2'].patchValue(false);
          Object.keys(this.membership.controls).forEach(field => { // {1}
            const control = this.membership.get(field);            // {2}
            control.markAsTouched({ onlySelf: true });       // {3}
          });
        });
      } 
    }
    
  }  
}
